import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";

export const DeleteIgnoreZoneAssignmentDialog = ({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle id="delete-ignore-zone-assignment-dialog" sx={{ fontFamily: "Mulish" }}>
      Are you sure you&apos;d like to delete this Ignore zone assignment?
    </DialogTitle>
    <DialogActions>
      <OrangeTextButton onClick={onCancel} text="Cancel" disabled={false} />
      <OrangeTextButton onClick={onConfirm} text="Delete" disabled={false} />
    </DialogActions>
  </Dialog>
);
